import { connect } from 'react-redux';
import { hideModal } from '../../modalsSlice';
import subscribeGift from '../../../subscriptionGift/subscriptionGiftSlice';
import FormSendGiftModal from './FormSendGiftModal';

const dispatchProps = {
  hideModal,
  subscribeGift,
};

export default connect(null, dispatchProps)(FormSendGiftModal);
